/**
 * 加载CSS文件
 * @todo 后续需要增加根据设备加载相应样式文件的功能
 */
//import './css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';
//v4.0去掉theme？
import 'bootstrap/dist/css/bootstrap-theme.min.css';
//import './css/bootstrap-theme.min.css'
import './css/common.css';
import 'bootstrap/dist/js/bootstrap.min.js';



// WEBPACK FOOTER //
// ./usr/lib/ui/src/styles/index.js